/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable function-paren-newline */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, FlexContainer } from '../../../globalStyles';
import { apiEndPoints } from '../../../services/axios/endPoints';
import { WebService } from '../../../services/axios/webServices';
import TabsTable from '../../Common/Tabs_Table';
import { TableContainer } from '../../Common/Tabs_Table/TabsTable.style';
import { Bttn } from '../CreateWorkOrder/AssetSelection/AssetSelection.style';
import { Creators as UpsertWorkOrderCreators } from '../CreateWorkOrder/store';
import {
  DetailLabel,
  DetailText,
  EnlargedImage,
  HeaderText,
  ModalListHeader,
  PartDetailsContainer,
  PartHeader,
  PartImage,
  PartName,
  PartsContainer
} from './WorkOrderDetails.style';
import { useActions } from '../../../store/hooks/useActions';
import { sagaCatchBlockHandling } from '../../../store/utility/sagaErrorHandling';
import Toast from '../../Common/Toast';
import { Input } from '../../Common/Input/Input';
import { getStringLocale } from '../../../constants/language';
import PopUpModal from '../../Common/PopUpModal/Modal.view';
import DynamicSVGIcon from '../../Common/DynamicSVGIcon';
import { CancelBlack } from '../../../assets/icons';

const WoSelectedAsset = ({ setAssetListModal, backHandler }) => {
  const { assetShortlist, assetListMeta, submitUrl, shortListWithQty } =
    useSelector((state) => state.upsertWorkOrder);
  const type = useSelector((state) => state.workOrders.type);
  const { workOrderId } = useSelector((state) => state.workOrders);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const dispatch = useDispatch();
  const { setAssetShortlist, getWorkOrderDetails } = useActions();

  const handleShortList = (entry) => {
    const check = assetShortlist.some(
      (ele) =>
        ele.mainPartNumber === entry.mainPartNumber &&
        ele.inventPartnumber === entry.inventPartnumber &&
        ele.qtyAvailable === entry.qtyAvailable
    );
    if (!check) {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist([...assetShortlist, entry])
      );
    } else {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist(
          assetShortlist.filter(
            (ele) =>
              !(
                ele.mainPartNumber === entry.mainPartNumber &&
                ele.inventPartnumber === entry.inventPartnumber
              )
          )
        )
      );
    }
  };

  const postReqOnConfirm = async () => {
    const url = submitUrl || apiEndPoints.addPartAdd;
    try {
      const res = await WebService.post(
        `${url}/${workOrderId}`,
        JSON.stringify(assetShortlist)
      );
      dispatch(UpsertWorkOrderCreators.setAssetShortlist([]));
      if (res.status >= 200) {
        // 2 params required for details
        getWorkOrderDetails({ workOrderId, type });
      } else {
        throw res;
      }
    } catch (err) {
      console.log(err, 'error');
      const payload = sagaCatchBlockHandling(err);
      setError(payload?.error);
    }
  };

  const additionalColumns = [
    {
      label: 'Qty Required',
      key: 'qtyRequired',
      type: 'number',
      placeholder: '',
      defaultValue: 0,
      validation: (val) => val > 0
    }
  ];

  const inputValidations = () =>
    assetShortlist.every((e) =>
      additionalColumns.every((col) => {
        const { key, validation, type } = col;
        let value = e[key];
        if (type === 'number') {
          // string to int
          if (typeof value === 'string') {
            value = parseInt(value, 10);
          }
        }
        return validation(value);
      })
    );

  const onConfirm = () => {
    postReqOnConfirm();
    setAssetShortlist([]);
    setAssetListModal(false);
  };

  const isValid = inputValidations();

  const handleCancel = () => {
    setAssetListModal(false);
    setAssetShortlist([]);
  };

  useEffect(() => {
    setLoading(false);
  });

  const handleChange = (e, asset) => {
    const updatedAssetShortList = assetShortlist.map((item) => {
      if (item.mainPartNumber === asset.mainPartNumber) {
        // Or use any unique identifier
        return {
          ...item,
          qtyRequired: Math.floor(e.target.value)
        };
      }
      return item;
    });

    dispatch(UpsertWorkOrderCreators.setAssetShortlist(updatedAssetShortList));
  };

  const [enlargeImage, setEnlargeImage] = useState({});

  return (
    <>
      <div
        style={{
          height: 'calc(100% - 6rem)',
          // width: 'calc(100% - 2rem)',
          overflow: 'auto',
          padding: '1rem'
        }}
      >
        {assetShortlist?.map((asset) => {
          const assetInList = assetShortlist.some(
            (ele) =>
              ele.mainPartNumber === asset.mainPartNumber &&
              ele.inventPartnumber === asset.inventPartnumber &&
              ele.qtyAvailable === asset.qtyAvailable
          );

          return (
            <>
              <PartsContainer style={{ width: '100%' }}>
                <PartHeader>
                  <PartImage
                    src={asset?.unfurlImageUrl}
                    width='120px'
                    height='150px'
                    onClick={() => {
                      setEnlargeImage({ display: true, asset });
                    }}
                  />
                  <PartName>{asset?.partName}</PartName>
                </PartHeader>
                <PartDetailsContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      {getStringLocale('Qty Available', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${asset?.qtyAvailable || '-'}`}</DetailText>
                  </FlexContainer>
                </PartDetailsContainer>
                <FlexContainer
                  className='ai_center'
                  style={{ margin: '1rem 0rem 0 0rem' }}
                >
                  <Input
                    width='45vw'
                    type='number'
                    placeholder={getStringLocale('Enter Quantity', 'en')}
                    value={asset?.qtyRequired || ''}
                    name='quantity'
                    onChange={(e) => {
                      handleChange(e, asset);
                    }}
                  />
                  <Button
                    style={{
                      borderRadius: '10px',
                      width: '100%',
                      padding: '0.8rem',
                      marginLeft: '1rem'
                    }}
                    onClick={() => {
                      handleShortList(asset);
                    }}
                    className={assetInList && 'remove'}
                    dark={true}
                  >
                    {assetInList
                      ? getStringLocale('Remove', 'en')
                      : getStringLocale('Add', 'en')}
                  </Button>
                </FlexContainer>
              </PartsContainer>
            </>
          );
        })}
      </div>
      <FlexContainer className='jc_center ac_center' style={{ gap: '2rem' }}>
        <Bttn dark onClick={backHandler}>
          {getStringLocale('Back', 'en')}
        </Bttn>
        {/* <Bttn dark onClick={handleCancel}>
          Cancel
        </Bttn> */}
        <Bttn dark disabled={!isValid} onClick={onConfirm}>
          {getStringLocale('Confirm', 'en')}
        </Bttn>
      </FlexContainer>
      {enlargeImage?.display && (
        <PopUpModal
          closeModalHandler={() => {
            setEnlargeImage({});
          }}
          style={{ height: '60%' }}
        >
          <FlexContainer
            className='ai_center jc_spacebetween'
            style={{ marginBottom: '2rem' }}
          >
            <HeaderText>
              {getStringLocale(
                `${enlargeImage?.asset?.inventPartNumber}`,
                'en'
              )}
            </HeaderText>
            <div
              style={{ textAlign: 'end' }}
              onClick={() => {
                setEnlargeImage({});
              }}
            >
              <DynamicSVGIcon iconUrl={CancelBlack} width='1.5rem' />
            </div>
          </FlexContainer>

          <div style={{ height: '90%' }}>
            <EnlargedImage
              src={enlargeImage?.asset?.unfurlImageUrl}
              alt='part'
            />
          </div>
        </PopUpModal>
      )}
      {error && (
        <Toast
          message={error}
          header='Error'
          style={{ right: 30, zIndex: 20 }}
          fn={() => setError('')}
        />
      )}
    </>
  );
};

export default WoSelectedAsset;
